import { useMutation } from '@tanstack/react-query';

import { useImpState } from '../../app/hooks';
import { ApiResponse } from '../../types/Api';
import { ApiRequestV2, httpRequestV2 } from '../http/client';
import { Method } from '../http/httpConsts';

interface CreatePINRequest {
  consumerUUID: string;
  newPin: string;
  oldPin: string;
}

export function useCreatePin() {
  const { consumerInfo } = useImpState();

  return useMutation<any, ApiResponse, CreatePINRequest>({
    mutationFn: (params) =>
      createPINAccount({
        consumerUUID: consumerInfo.consumerUUID,
        newPin: params.newPin,
        oldPin: '',
      }),
  });
}

async function createPINAccount({
  consumerUUID,
  newPin,
  oldPin,
}: CreatePINRequest) {
  const req: ApiRequestV2 = {
    path: '/v1/account/pin',
    method: Method.POST,
    body: {
      consumerUUID,
      newPin,
      oldPin,
    },
  };
  return httpRequestV2(req);
}
